import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary.js';
import LoadingSpinner from './components/LoadingSpinner.js';
import MapPage from './pages/MapPage.js';

const PlacePage = lazy(() => import('./pages/PlacePage.js'));
const SearchPage = lazy(() => import('./pages/SearchPage.js'));
const DirectionsPage = lazy(() => import('./pages/DirectionsPage.js'));
const ProfilePage = lazy(() => import('./pages/ProfilePage.js'));
const LoginPage = lazy(() => import('./pages/LoginPage.js'));
const ContributePage = lazy(() => import('./pages/ContributePage.js'));
const AdminPage = lazy(() => import('./pages/AdminPage.js'));
const SharedListPage = lazy(() => import('./pages/SharedListPage.js'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPasswordPage.js'));
const ResetPasswordPage = lazy(() => import('./pages/ResetPasswordPage.js'));
const UserProfilePage = lazy(() => import('./pages/UserProfilePage.js'));
const ActivityFeedPage = lazy(() => import('./pages/ActivityFeedPage.js'));
const CommandCenterPage = lazy(() => import('./pages/CommandCenterPage.js'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage.js'));

export default function App() {
  return (
    <ErrorBoundary>
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          <Route path="/" element={<MapPage />} />
          <Route path="/place/:id" element={<PlacePage />} />
          <Route path="/search" element={<SearchPage />} />
          <Route path="/directions" element={<DirectionsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/contribute" element={<ContributePage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/list/:id" element={<SharedListPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route path="/user/:id" element={<UserProfilePage />} />
          <Route path="/activity" element={<ActivityFeedPage />} />
          <Route path="/command" element={<CommandCenterPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
}
